import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { ProductContext } from "../../../context/ProductContext";
import { useNavigation } from "../../../utils/navigation";
import { useTranslation } from "react-i18next";

const Container = styled.div``;
const CategoryContainer = styled.div`
  position: relative;
  font-weight: 500;
  font-size: var(--font-size-base);
  z-index: 2;
`;

const List = styled.div`
  padding: 0;
  border: 0;
  outline: none;
  list-style: none;
  position: absolute;
  right: 0%;
  top: calc(100% + 20px);

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  width: 660px;
  background-color: var(--bg-100);
  border: 1px solid var(--bg-200);
  border-radius: var(--border-radius-large);
  gap: 4px;
  padding: var(--spacing-md);
  box-shadow: var(--shadow-large);
  max-height: calc(100vh - var(--navbar-height-desktop) - 160px);
  overflow: auto; /* omogućava skrolanje unutar div-a */
  -webkit-overflow-scrolling: touch;
`;
const MaskDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: rgba(15, 17, 20, 0.25);
`;
const ListItem = styled.div`
  text-decoration: none;
  color: var(--text-100);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--border-radius-small);

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--bg-100);
  transition: background-color var(--transition-fast), color var(--transition-fast);

  &:hover {
    background-color: var(--bg-200);
    color: var(--primary-200);
  }
  &:hover svg {
    opacity: 1;
    transform: translateX(0);
  }
`;
const ListTitle = styled.div`
  grid-column: 1 / -1;
  font-size: var(--font-size-small);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-200);
  padding: 0 var(--spacing-md) var(--spacing-sm);
`;
const Span = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-transform: uppercase;
  font-size: var(--font-size-small);
  font-weight: 600;
  letter-spacing: 0.4px;
  color: ${({ $active }) => ($active ? "var(--primary-200)" : "var(--text-100)")};
  padding: 8px 2px;
  transition: color var(--transition-fast);

  &::after {
    content: "";
    position: absolute;
    left: 2px;
    right: 2px;
    bottom: 4px;
    height: 2px;
    border-radius: 2px;
    background-color: var(--primary-200);
    transform: scaleX(${({ $active }) => ($active ? 1 : 0)});
    transform-origin: center;
    transition: transform var(--transition-fast);
  }

  &:hover {
    color: var(--primary-200);
  }
  &:hover::after {
    transform: scaleX(1);
  }
  svg {
    fill: var(--text-200);
    transition: fill 0.3s ease; /* Dodaj tranziciju za glatki prelaz boje */
  }
  &:hover svg {
    fill: var(--primary-200); /* Boja pri hoveru */
  }
`;
const FlexDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;
const CategoryList = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { categories } = useContext(ProductContext);

  const navigate = useNavigate();
  const { goToCategory } = useNavigation();
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setShow(false);
    }
  };

  return (
    <>
      {show && <MaskDiv onClick={() => setShow(!show)} />}
      <Container>
        <CategoryContainer
          onClick={() => {
            setShow(!show);
          }}
        >
          <Span $active={show}>
            {t("HEADER.BRANDS")}
            <svg
              width="14px"
              height="14px"
              viewBox="0 0 1024 1024"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                transform: show ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease",
              }}
            >
              <path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z" />
            </svg>
          </Span>
          {show && (
            <List ref={containerRef}>
              <ListTitle>{t("HEADER.BRANDS")}</ListTitle>
              {categories.map((category, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(goToCategory(category.name))}
                >
                  <FlexDiv>{category.name}</FlexDiv>
                </ListItem>
              ))}
            </List>
          )}
        </CategoryContainer>
      </Container>
    </>
  );
};

export default CategoryList;
